module.exports = __webpack_public_path__ + "static/media/copyright.e193ef92.svg";